import styled from '@emotion/styled';

export const FormContainer = styled.div`
  padding: 0px 0px 16px;
  background-color: #f5f5f5;
  border-radius: 8px;
  max-width: 768px;
  .finalReading {
    color: red;
    font-size: 16px;
    margin-bottom: 8px;
    font-weight: bold;
  }
  .dateRange {
    font-size: 16px;
    margin-bottom: 8px;
    font-weight: bold;
  }
`;

export const FormRow = styled.div`
  display: flex;
  margin-top: 16px;
  align-items: center;
  justify-content: space-between;
  > * {
    width: calc(50% - 8px);
    flex-direction: column;
  }
  .fieldlabel {
    margin-bottom: 8px;
    display: inline-block;
  }
`;
